/* Store customizations ported from Be Yours 6.8.0 (global.js). Keep all custom JS here. */

// Personalize button toggle - start

(function () {
  var SLUG      = 'add-personalization-15-00';
  var HIDE_WHEN = 'no';
  var CLASS     = 'cl-hide-personalize';

  var style = document.createElement('style');
  style.textContent = 'html.' + CLASS + ' .customily-personalize-button{display:none !important;}';
  (document.head || document.documentElement).appendChild(style);

  function currentValue() {
    var radio = document.querySelector('[data-option-slug="' + SLUG + '"] input[type="radio"]:checked');
    if (radio) return radio.value;
    var select = document.querySelector('[data-option-slug="' + SLUG + '"] select');
    if (select) return select.value;
    return '';
  }

  var lastValue = null;

  function apply() {
    var v = (currentValue() || '').trim().toLowerCase();
    document.documentElement.classList.toggle(CLASS, v === HIDE_WHEN);

    // Added in 9.5.1 update: switching to "No" also cancels an open personalization.
    // Without this, the Customily fields stayed in the form and were added to the cart.
    // Same event Customily's own "Remove" link uses (collapses the options, detaches them).
    if (v === HIDE_WHEN && lastValue !== null && lastValue !== HIDE_WHEN) {
      window.dispatchEvent(new CustomEvent('customily-options-collapse'));
    }
    lastValue = v;
  }

  var queued = null;
  function schedule() {
    if (queued) return;
    queued = setTimeout(function () { queued = null; apply(); }, 0);
  }

  // Option changed (capture phase, delegated — survives section re-renders)
  document.addEventListener('change', schedule, true);

  // Section re-render / late-injected Customily markup
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  apply();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
})();

// Personalize button toggle - end